import { render, staticRenderFns } from "./BaseMap.vue?vue&type=template&id=10967f54&scoped=true"
import script from "./BaseMap.vue?vue&type=script&lang=js"
export * from "./BaseMap.vue?vue&type=script&lang=js"
import style0 from "./BaseMap.vue?vue&type=style&index=0&id=10967f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10967f54",
  null
  
)

export default component.exports